import { optional, withDependencies } from '@wix/thunderbolt-ioc'
import { NativeMobileApis, NativeMobileWixCodeSdkHandlers, NavigationOptions } from '../types'
import { RendererExtensionsSymbol, SdkHandlersProvider } from '@wix/thunderbolt-symbols'

export const nativeMobileSdkHandlersProvider = withDependencies(
	[optional(RendererExtensionsSymbol)],
	(extensions: NativeMobileApis): SdkHandlersProvider<NativeMobileWixCodeSdkHandlers> => ({
		getSdkHandlers: () => ({
			dismissAllModals: () => {
				extensions.navigation?.dismissAllModals?.() ?? console.log('dismissAllModals is not supported')
			},
			openURL: (url: string) => {
				if (extensions.navigation?.openURL) {
					return extensions.navigation.openURL(url)
				} else {
					const msg = 'openURL is not supported'
					console.log(msg)
					return Promise.reject(msg)
				}
			},
			toScreen: (screenId: string, options?: NavigationOptions) => {
				if (extensions.navigation?.toScreen) {
					return extensions.navigation.toScreen(screenId, options)
				} else {
					const msg = 'toScreen is not supported'
					console.log(msg)
					return Promise.reject(msg)
				}
			},
		}),
	})
)
